import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const BreadcrumbNavigation = ({ customBreadcrumbs = null }) => {
  const location = useLocation();

  const routeLabels = {
    '/csv-import-dashboard': 'Importar',
    '/product-catalog-manager': 'Catálogo',
    '/product-editor': 'Editor',
    '/kit-builder': 'Kits',
    '/export-center': 'Exportar'
  };

  const generateBreadcrumbs = () => {
    if (customBreadcrumbs) return customBreadcrumbs;

    const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
    const breadcrumbs = [{ label: 'Início', path: '/' }];

    let currentPath = '';
    pathSegments?.forEach((segment) => {
      currentPath += `/${segment}`;
      const label = routeLabels?.[currentPath] || segment?.charAt(0)?.toUpperCase() + segment?.slice(1);
      breadcrumbs?.push({ label, path: currentPath });
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs?.length <= 1) return null;

  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex items-center gap-2 flex-wrap">
        {breadcrumbs?.map((crumb, index) => {
          const isLast = index === breadcrumbs?.length - 1;
          const isFirst = index === 0;

          return (
            <li key={crumb?.path} className="flex items-center gap-2">
              {!isFirst && (
                <Icon 
                  name="ChevronRight" 
                  size={16} 
                  className="text-muted-foreground"
                />
              )}
              {isLast ? (
                <span className="font-medium text-foreground caption">
                  {crumb?.label}
                </span>
              ) : (
                <Link
                  to={crumb?.path}
                  className="caption text-muted-foreground hover:text-foreground transition-smooth hover:underline"
                >
                  {crumb?.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
      <div className="hidden lg:block mt-2">
        <div className="h-px bg-border" />
      </div>
    </nav>
  );
};

export default BreadcrumbNavigation;